import { v4 } from 'uuid';
import {
  CostItem,
  CostItemsFieldsOptions,
} from '../Configuration/Configuration.types';
import { StockItem } from './StockItems.types';

export function getRowKey(
  item?: StockItem | { partId?: number; consumableId?: number },
) {
  return item
    ? JSON.stringify({
        partId: item.partId,
        consumableId: item.consumableId,
      })
    : v4();
}

interface PartExpenses {
  [x: string]: number | undefined;
  buyPrice: number;
  ipi: number;
  fixedCost: number;
  taxReplacement: number;
  icmsExemption?: number;
  freightCost: number;
  otherExpenses: number;
  operationalExpenses?: number;
}

interface EnabledPartExpenses {
  [x: string]: boolean | undefined;
  ipi?: boolean;
  fixed_cost?: boolean; // eslint-disable-line
  tax_replacement?: boolean; // eslint-disable-line
  icms?: boolean;
  freight?: boolean;
  accessory?: boolean;
  operational?: boolean;
}

export function getPartRealCost(
  expenses: PartExpenses,
  costTypes: CostItem[],
): number {
  let result = expenses.buyPrice;

  const enabled = costTypes.reduce<EnabledPartExpenses>((acc, curr) => {
    const field = CostItemsFieldsOptions[curr.field].substring(
      CostItemsFieldsOptions[curr.field].lastIndexOf('.'),
    );

    return { ...acc, [field]: curr.active };
  }, {});

  if (enabled.operational) {
    result += (result / 100) * (expenses.operationalExpenses ?? 0);
  }

  if (enabled.fixed_cost) {
    result += expenses.buyPrice * (expenses.fixedCost / 100);
  }

  if (enabled.ipi) {
    result += expenses.buyPrice * (expenses.ipi / 100);
  }

  if (enabled.tax_replacement) {
    result += expenses.taxReplacement;
  }

  if (enabled.freight) {
    result += expenses.freightCost;
  }

  if (enabled.accessory) {
    result += expenses.otherExpenses;
  }

  if (enabled.icms && expenses.icmsExemption) {
    result -= expenses.icmsExemption;
  }

  return result === 0 ? 0 : ((result + Number.EPSILON) * 100) / 100;
}

export function getPartProfitMargin(realCost: number, sellCost: number) {
  try {
    let margin = 0;
    if (realCost !== 0 && sellCost !== 0) {
      margin = sellCost / realCost - 1;
    }

    return Math.floor((margin + Number.EPSILON) * 100) / 100;
  } catch (err) {
    return 0;
  }
}
